<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="titlepage">
<div class="ipadfp"><span aria-label="page 1" epub:type="pagebreak" id="page_1" role="doc-pagebreak"><span aria-label="page 2" epub:type="pagebreak" id="page_2" role="doc-pagebreak"><span aria-label="page 3" epub:type="pagebreak" id="page_3" role="doc-pagebreak"><img alt="The Somatic Therapy Workbook by Livia Shapiro, Ulysses Press" class="imagefp" src="e9781646040964/images/title.jpg"/></span></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?d8841dc2